import React, { useEffect, useState } from "react";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import { postFormData } from "../../../helpers/api_helper";
import { Spin } from "antd";
import { POST_TestMethodsInsert } from "../../../helpers/url_helper";
import { capitalizeString, errorMessage } from "../CommonFunctions";

const QuickAddTestMethod = ({ showModal, setShowModal, fnCallback }) => {
  const [isLoading, setIsLoading] = useState(false);
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const validationSchemaTestMethodAdd = Yup.object().shape({
    TestMethodCodeType: Yup.number(),
    TestMethodName: Yup.string().when(
      "TestMethodCodeType",
      ([TestMethodCodeType], schema) => {
        if (TestMethodCodeType == 2)
          return Yup.string().required("Test Method Name is required field");
        return schema;
      }
    ),
    TestMethodCountryCode: Yup.string().when(
      "TestMethodCodeType",
      ([TestMethodCodeType], schema) => {
        if (TestMethodCodeType == 1)
          return Yup.string().required("Country Code is required field");
        return schema;
      }
    ),
    StandardCode: Yup.string().when(
      "TestMethodCodeType",
      ([TestMethodCodeType], schema) => {
        if (TestMethodCodeType == 1)
          return Yup.string().required("Standard Code is required field");
        return schema;
      }
    ),
    Delimiter: Yup.string().when(
      "TestMethodCodeType",
      ([TestMethodCodeType], schema) => {
        if (TestMethodCodeType == 1)
          return Yup.string().required("Delimiter is required field");
        return schema;
      }
    ),
    MethodYear: Yup.string().when(
      "TestMethodCodeType",
      ([TestMethodCodeType], schema) => {
        if (TestMethodCodeType == 1)
          return Yup.string().required("Year is required field");
        return schema;
      }
    ),
    DisplayName: Yup.string().trim().required("Display Name is required field"),
  });

  const formikTestMethodAdd = useFormik({
    validationSchema: validationSchemaTestMethodAdd,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitTestMethodAdd(values, formikHelpers),
    initialValues: {
      TestMethodCodeType: 1,
      TestMethodName: "",
      TestMethodCountryCode: "",
      StandardCode: "",
      Delimiter: "",
      MethodYear: "",
      Description: "",
      TestMethodIsNABL: false,
      DisplayName: "",
      NickName: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      TestMethodIsNABL,
      TestMethodCodeType,
      TestMethodCountryCode,
      StandardCode,
      Delimiter,
      MethodYear,
      DisplayName,
    },
  } = formikTestMethodAdd;

  function createTestMethodName(CountryCode, StandardCode, Delimiter, Year) {
    let name = "";

    if (CountryCode) {
      name += CountryCode + " ";
    }
    if (StandardCode) {
      name += StandardCode + " ";
    }
    if (Delimiter) {
      name += Delimiter + " ";
    }
    if (Year) {
      name += Year;
    }

    formikTestMethodAdd.setFieldValue("TestMethodName", name);
    formikTestMethodAdd.setFieldValue("DisplayName", name);
  }

  useEffect(() => {
    if (TestMethodCodeType == 1) {
      createTestMethodName(
        TestMethodCountryCode,
        StandardCode,
        Delimiter,
        MethodYear
      );
    }
  }, [TestMethodCountryCode, StandardCode, Delimiter, MethodYear]);

  const handleValidSubmitTestMethodAdd = (values) => {
    setIsLoading(true);
    let formData = new FormData();

    formData.append("CompanyIDEncrypted", AuthUser?.CompanyIDEncrypt);
    formData.append("BranchIDEncrypted", AuthUser?.BranchIDEncrypt);
    formData.append("TestMethod", values?.TestMethodName.trim());
    formData.append("TestMethodCodeType", values?.TestMethodCodeType);
    formData.append("DisplayName", values?.DisplayName.trim());
    formData.append("NickName", values?.NickName.trim());
    formData.append(
      "TestMethodCountryCode",
      values?.TestMethodCountryCode ? values?.TestMethodCountryCode.trim() : ""
    );

    formData.append(
      "StandardCode",
      values?.StandardCode ? values?.StandardCode.trim() : ""
    );
    formData.append(
      "Delimiter",
      values?.Delimiter ? values?.Delimiter.trim() : ""
    );
    formData.append(
      "MethodYear",
      values?.MethodYear ? values?.MethodYear.trim() : ""
    );

    formData.append("Description", values?.Description);
    formData.append("IsNABL", values?.TestMethodIsNABL);
    formData.append(
      "VerificationDoneByEncrypted",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0"
    );
    formData.append("TestMethodRefDocFilePathURL", "");
    formData.append("TestMethodRefDocFilePath", "");
    formData.append(
      "CreatedByEncrypted",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0"
    );

    postFormData(POST_TestMethodsInsert, formData)
      .then((response) => {
        if (response?.IsSuccess) {
          fnCallback(
            response?.EncryptID,
            values?.TestMethodName.trim(),
            values?.NickName.trim()
          );
          formikTestMethodAdd.resetForm();
          setShowModal(false);
          setIsLoading(false);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <Modal className="fade" show={showModal} onHide={setShowModal} size="lg">
      <Spin
        size="large"
        spinning={isLoading}
        tip={"Loading..."}
        style={{ position: "fixed" }}
      >
        <FormikProvider value={formikTestMethodAdd}>
          <Form onSubmit={formikTestMethodAdd.handleSubmit}>
            <Modal.Header>
              <Modal.Title>Test Method</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => {
                  formikTestMethodAdd.resetForm();
                  setShowModal(false);
                }}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={12}>
                  <label>
                    Name <span className="text-danger">*</span>
                  </label>
                </Col>
                <Col lg={12}>
                  <div className="form-check custom-checkbox mb-2 form-check-inline ms-1">
                    <input
                      type="radio"
                      className="form-check-input"
                      id="customRadioStandard"
                      name="TestMethodCodeType"
                      title="Standard Name"
                      style={{ cursor: "pointer" }}
                      checked={TestMethodCodeType == 1 ? true : false}
                      onChange={() => {
                        formikTestMethodAdd.setFieldValue(
                          "TestMethodCodeType",
                          1
                        );
                        formikTestMethodAdd.setFieldValue("TestMethodName", "");
                        formikTestMethodAdd.setFieldValue("DisplayName", "");
                      }}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="customRadioStandard"
                    >
                      Standard Name
                    </label>
                  </div>
                  <div className="form-check custom-checkbox mb-2 form-check-inline ms-1">
                    <input
                      type="radio"
                      className="form-check-input"
                      id="customRadioManual"
                      name="TestMethodCodeType"
                      title="Manual"
                      style={{ cursor: "pointer" }}
                      checked={TestMethodCodeType == 2 ? true : false}
                      onChange={() => {
                        formikTestMethodAdd.setFieldValue("DisplayName", "");
                        formikTestMethodAdd.setFieldValue(
                          "TestMethodCodeType",
                          2
                        );
                        formikTestMethodAdd.setFieldValue(
                          "TestMethodCountryCode",
                          ""
                        );
                        formikTestMethodAdd.setFieldValue("StandardCode", "");
                        formikTestMethodAdd.setFieldValue("Delimiter", "");
                        formikTestMethodAdd.setFieldValue("MethodYear", "");
                      }}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="customRadioManual"
                    >
                      Manual
                    </label>
                  </div>
                </Col>
                {TestMethodCodeType == 1 ? (
                  <Col lg={12}>
                    <Row>
                      <Col lg={4} className="pe-zero">
                        <Field
                          label="Country Code"
                          name="TestMethodCountryCode"
                          placeholder={"Enter Country Code"}
                          component={CustomInput}
                          required
                          maxLength={4}
                          disabled={TestMethodCodeType == 2 ? true : false}
                        />
                      </Col>
                      <Col lg={4} className="pe-zero">
                        <Field
                          label="Standard Code"
                          name="StandardCode"
                          placeholder={"Enter Standard Code"}
                          component={CustomInput}
                          required
                          maxLength={4}
                          disabled={TestMethodCodeType == 2 ? true : false}
                        />
                      </Col>
                      <Col lg={2} className="pe-zero">
                        <Field
                          label="Delimiter"
                          name="Delimiter"
                          placeholder={"Delimiter"}
                          component={CustomInput}
                          required
                          maxLength={4}
                          disabled={TestMethodCodeType == 2 ? true : false}
                        />
                      </Col>
                      <Col lg={2}>
                        <Field
                          label="Year"
                          name="MethodYear"
                          placeholder={"Year"}
                          component={CustomInput}
                          required
                          maxLength={4}
                          disabled={TestMethodCodeType == 2 ? true : false}
                        />
                      </Col>
                    </Row>
                  </Col>
                ) : (
                  ""
                )}
                <Col lg={12}>
                  <Field
                    name="TestMethodName"
                    placeholder={"Enter Test Method Name"}
                    component={CustomInput}
                    required
                    maxLength={100}
                    disabled={TestMethodCodeType == 1 ? true : false}
                    onChange={(e) => {
                      formikTestMethodAdd.setFieldValue(
                        "TestMethodName",
                        capitalizeString(e)
                      );
                    }}
                    onBlur={(e) => {
                      if (!DisplayName) {
                        formikTestMethodAdd.setFieldValue(
                          "DisplayName",
                          e?.target?.value ?? ""
                        );
                      }
                    }}
                  />
                </Col>
                <Col lg={12}>
                  <Field
                    label="Description"
                    name="Description"
                    placeholder={"Enter Description"}
                    component={CustomTextArea}
                    rows={3}
                    maxLength={100}
                  />
                </Col>
                <Col lg={12}>
                  <Field
                    label="Display Name"
                    name="DisplayName"
                    placeholder={"Enter Display Name"}
                    component={CustomInput}
                    required
                    maxLength={500}
                    onChange={(e) => {
                      formikTestMethodAdd.setFieldValue(
                        "DisplayName",
                        capitalizeString(e)
                      );
                    }}
                  />
                </Col>
                <Col lg={12}>
                  <Field
                    label="Nick Name"
                    name="NickName"
                    placeholder={"Enter Nick Name"}
                    component={CustomInput}
                    maxLength={500}
                  />
                </Col>
                <Col lg={12}>
                  <div className="d-flex mb-2">
                    <label>NABL &nbsp;</label>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckChecked"
                        title={TestMethodIsNABL == true ? "Yes" : "No"}
                        checked={TestMethodIsNABL}
                        onChange={() => {
                          formikTestMethodAdd.setFieldValue(
                            "TestMethodIsNABL",
                            !TestMethodIsNABL
                          );
                        }}
                        style={{ cursor: "pointer" }}
                      ></input>
                    </div>
                  </div>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <button className="btn btn-primary btn-sm me-2" type="submit">
                <i className="fa-solid fa-floppy-disk"></i> Submit
              </button>
              <Button
                variant="danger btn-sm"
                onClick={() => {
                  formikTestMethodAdd.resetForm();
                  setShowModal(false);
                }}
              >
                <i className="fa fa-cancel"></i> Cancel
              </Button>
            </Modal.Footer>
          </Form>
        </FormikProvider>
      </Spin>
    </Modal>
  );
};

export default QuickAddTestMethod;
